import { Routes } from '@angular/router';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_CUSTOMER_QUERY } from './kundenabfrage.shared';

export const kundenabfrageRoutes: Routes = [
  {
    path: 'kundenabfrage',
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/customer-query.component').then(
            (o) => o.CustomerQueryComponent
          ),
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('./components/customer-detail/customer-detail.component').then(
                (o) => o.CustomerDetailComponent
              ),
          },
          {
            path: '',
            loadComponent: () =>
              import('./components/customer-input/customer-input.component').then(
                (o) => o.CustomerInputComponent
              ),
            pathMatch: 'full',
          },
          { path: '**', redirectTo: '' },
        ],
      },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_CUSTOMER_QUERY },
  },
];
